import { Badge } from '@/shared/components/ui/badge';
import { MembershipRole } from '@/types/api/membership';
import { membershipRoleBadge, membershipRoleLabel } from '../utils/membership-role';

export function MembershipRoleBadge({ role }: { role: MembershipRole }) {
  return <Badge className={membershipRoleBadge(role)}>{membershipRoleLabel(role)}</Badge>;
}
